"use strict";
checkList.classy.controller({
    name: 'ChairtyThresholdExceeded',
    inject: ['$scope', 'RestService', 'ApplicationService', 'PutService', 'SchoolModelService'],
    init: function () 
    {
        this.$.setAnswer(77);
    },
    charityThresholdExceededComplete: function () 
    {
        var caseNo = 'case77';
        var queue = [];
        var charity;
        var income = this.ApplicationService.getFamilyData().awardData.reportedIncome;
        if (this.$.answer.choice != 2)
            delete this.$.answer.amount;

        if (this.$.answer.choice == 0) {
            charity = this.SchoolModelService.get()[0].Thresh_Charity_Cap;
        }
        else if (this.$.answer.choice == 1) {
            charity = this.ApplicationService.getFamilyData().awardData.charity.charity;
        }
        else if (this.$.answer.choice == 2) {
            charity = this.$.answer.amount;
        }
        this.ApplicationService.getFamilyData().thresholds.Thresh_Charity_Cap = charity;
        this.ApplicationService.getFamilyData().thresholds.Thresh_Charity_Percent = Math.ceil((charity / income * 100));

        queue.push(this.PutService.putThresholds());
        this.$.alertPut(queue, caseNo, 0, this.$.answer);
    }
});
